<template>
    <div>
        <span>©2026 Copyright© 酷米 ALL Rights Reserved</span>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

